<template>
<!-- 进入单个的博客页面 -->
    <div id="single-blog">
        <h1>{{blog.title}}</h1>
        <article>{{blog.content}}</article>
        <p>{{blog.author}}</p>
        <p>分类</p>
        <ul>
            <li v-for="category in blog.categories" :key="category">       
                {{category}}      
            </li>
        </ul>
        <button @click="deleteSingleBlog()">删除</button>
        <router-link :to="'/edit/' + id">编辑</router-link>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name:'single-blog',
    data() {
        return {
            id: this.$route.params.id,
            blog: {}
        }
    },
    created(){
        axios.get("https://floralblog-c0454-default-rtdb.firebaseio.com/posts/"
        + this.id + ".json")
        .then((response) =>{
            this.blog = response.data;
        })
    },
    methods:{
        deleteSingleBlog(){
            axios.delete("https://floralblog-c0454-default-rtdb.firebaseio.com/posts/"
            + this.id + ".json")
            .then(response =>{
            this.$router.push({path:'/home'})
        })
        }
    },
}
</script>

<style>
#single-blog{
    max-width: 960px;
    margin: 0 auto;
    padding: 20px;
    background-color: gray;
    border: 1px dotted #aaa;
}
</style>


// WEBPACK FOOTER //
// src/components/SingleBlog.vue